<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-card>
      <div slot="header">Payroll Review
        <div class="card-header-actions">
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row class="mb-2">
        <b-col lg="4">
            <b-input-group>
              <b-input-group-prepend><label style="width:100px !important;">Payroll Date</label></b-input-group-prepend>
                    <b-form-input v-model="model.paymentdate" type='date' :state="!$v.model.paymentdate.$error"></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="3">
            <b-button class="btn btn-success" @click="getData()" > <i class="fa fa-play"></i> Process</b-button>
        </b-col>
      </b-row>
      <b-card no-body>
            <b-row v-if="(filterShow=='Hide')" class="mt-2">
                <b-col lg="4">
                    <b-form-group
                        label="Filter"
                        label-cols-sm="1"
                        label-size="sm"
                        label-for="filterInput"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>  
                </b-col> 
                <b-col lg="5">
                  <b-form-group
                    label="Filter On"
                    label-cols-sm="1"
                    label-size="sm"
                    description="Leave all unchecked to filter on all data"
                    class="mb-0">
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                      <b-form-checkbox value="projectname">Project</b-form-checkbox>
                      <b-form-checkbox value="locationname">Location</b-form-checkbox>
                      <b-form-checkbox value="crewname">Employee Name</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>                
                </b-col>                 
                <b-col lg="3">
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>
                </b-col>         
            </b-row>
            <b-table
                class="mb-0 text-nowrap"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="rptLines"
                :fields="tblData.fields"
                :current-page="tblData.page"
                :per-page="tblData.limit"
                :sort-by.sync="tblData.sortBy"
                :sort-desc.sync="tblData.sortDesc"
                :filter="filter"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
                <template v-slot:cell(index)="data">
                  {{data.index + 1}}
                </template>
                <template v-slot:cell(payrolldate)="data">
                      {{ data.item.payrolldate |  moment("D-MMM-YY") }}
                </template>
                <template v-slot:cell(takehomepay)="data">
                  {{data.item.takehomepay|numFormat}}
                </template>
            </b-table>
            <b-row class="mt-2">
                <b-col cols="4">
                    <div style="font-weight: bold;" class="ml-1">Total : {{uanguser}}
                        <div style="text-align:right; border:1px solid silver; width:200px;height:40px;border-top: 1px solid #000 ;border-bottom: 2px solid #000; background: #e6e6e6; display:inline;" class="pl-2 pt-2 pr-2">
                          {{subtotal.totalTHP | numFormat('0,0.00')}}</div>
                    </div>
                </b-col>
                <b-col cols="8">
                    <b-row >
                      <b-col cols="6" style="text-align:center">
                        <div>
                          Showing {{(tblData.page - 1) * tblData.limit + 1}}
                          to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                          of {{tblData.total}} entries,   <span class="ml-3 mr-1">limit per page :</span> 
                          <select  v-model="tblData.limit"  style="width:60px;">
                            <option>10</option>
                            <option>15</option>
                            <option>20</option>                            
                            <option>25</option>
                            <option>30</option>                            
                          </select>
                        </div>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch switch>
                          <b> {{ filterShow }}</b>  Filter by Project/Location, etc..
                        </b-form-checkbox>
                      </b-col>
                      <b-col cols="6">            
                        <b-pagination 
                          align="right"
                          :total-rows="tblData.total"
                          :per-page="tblData.limit"
                          v-model="tblData.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                </b-col>
            </b-row>
      </b-card>
  </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }

            tr.selisih {
              background: yellow;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px double #000 !important;
                background: #e6e6e6 !important;
            }
        }
    }
    iframe {
        border: 1px solid #ccc;
        width: 100%;
        height: 11in;
    }

</style>

<script>
import moment from 'moment';
import payroll from "../../apis/payroll";
import Loading from 'vue-loading-overlay';
import accounting from 'accounting-js'
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        paymentdate: { required },
    },
  }, 
  data() {
    return {
      horizontal: true,
      isLoading:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      model: {paymentdate:''},
      filterShow:'Show',
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      rptLines : [],
      subtotal : {},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
      fields: [
          { key: "crewnik" , 
            label: "Employee ID",
            thStyle: "width:100px",
            sortable: true
          },
          { key: "crewname" , 
            label: "Employee Name",
            thStyle: "width:250px",
            sortable: true
          },
          {
            key: "jabatan",
            label: "Job Title",
            thStyle: "width:150px",
          },
          {
            key: "departemen",
            label: "Department",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "CustName",
            label: "Client/Project",
            sortable: true
          },
         {
            key: "payrolldate",
            thStyle: "width:90px",
            label: "Payroll Date"
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "takehomepay",
            thStyle: "width:100px",
            label: "Take Home Pay",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
      ]
      },
      filter: null,
      filterOn: [],   
    };
  },
  components: {Loading},
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },  
  created: async function(){
      const dims = await payroll.salaryitem();
        for (let i = 0; i < dims.length; i += 1) {
          this.tblData.fields.push(          
            {
            key: dims[i].KdKompGaji,
            label: dims[i].NmKompGaji,
            variant: (dims[i].JenisKomp === 'Potongan') ? 'danger':'success',          
            formatter: "numberFormat",
            sortable: true
          },)
        }

        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(3, 'day');
        this.model.paymentdate=tgl2.format('YYYY-MM-25');
  },  
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
        this.subtotal.totalTHP = filteredItems.reduce((a, b) => a + b.takehomepay, 0);
    },      
    numberFormat(val) {
      return `${accounting.formatNumber(val)}`
    },
    
    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.isLoading=true;
        this.model.payrolldate=moment(this.model.paymentdate).format('YYYY-MM-DD'); 
        this.rptLines =  await payroll.review(this.model);
        this.tblData.total = this.rptLines.length;        
        this.subtotal.totalTHP = this.rptLines.reduce((a, b) => a + b.takehomepay, 0);
        this.isLoading=false;      
       }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
          
          const data ={};
            data.payrolldate= moment(this.model.paymentdate).format('YYYY-MM-DD'); 
            if ((this.filter) && (this.filterOn.length>0)) {
              this.filterOn.forEach( (itemFilt) => {
                data[itemFilt]=this.filter;
              });
            } 
            const response = await payroll.exportxls(data);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
      }
    },    
    close(){
      router.push("home");
    }
  }
};
</script>
